// extracted by mini-css-extract-plugin
module.exports = {"infotext-tooltip":"infoTextTooltip_infotext-tooltip__1g-te","infotext-tooltip__span-tooltip":"infoTextTooltip_infotext-tooltip__span-tooltip__10oXk"};